import { argvWantsHelp } from "../argv.ts";
import {
	type CatalogHelpTopic,
	catalogHelpTopic,
} from "../commands-catalog.ts";
import { unknownCommandError } from "../parse-helpers.ts";
import type { CliCommand } from "../types.ts";
import type { CommandRegistry } from "./registry.ts";

function helpTopicFromPath(path: readonly string[]): CatalogHelpTopic {
	const head = path[0];
	if (head == null || head === "") {
		return "root";
	}
	return catalogHelpTopic(head, path.slice(1)) ?? "root";
}

function helpCommand(topic: CatalogHelpTopic): CliCommand {
	return { command: "help", topic };
}

export function parseRegisteredCommand(
	registry: CommandRegistry,
	argv: readonly string[],
): CliCommand {
	if (argv.length === 0) {
		return helpCommand("root");
	}

	if (argv[0] === "--help" || argv[0] === "-h") {
		const matched = argv[1] ? registry.match(argv.slice(1)) : undefined;
		if (matched) {
			return helpCommand(helpTopicFromPath(matched.command.path));
		}
		return helpCommand("root");
	}

	const matched = registry.match(argv);
	if (!matched) {
		if (argvWantsHelp(argv)) {
			return helpCommand(helpTopicFromPath(argv));
		}
		throw unknownCommandError(argv[0] ?? "");
	}

	if (argvWantsHelp(argv) && matched.command.path[0] !== "help") {
		return helpCommand(helpTopicFromPath(matched.command.path));
	}

	return matched.command.parse(matched.rest);
}
